/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaContactCommercialViewProps } from './citta-contact-commercial';

export default (props: ICittaContactCommercialViewProps) => {
    const { 
        ContactContainer,
        ContactForm,
        ErrorMessage,
        EnquiryTitle,
        Name,
        EmailAddress,
        Occupation,
        PhoneNumber,
        Enquiry,
        Recaptcha,
        SubmitButton,
        Checkbox,
        ExpandCollapse 
    } = props;

    return (
        <Module {...ContactContainer}>
            {EnquiryTitle}
            {ExpandCollapse}
            <Node {...ContactForm}>
                {ErrorMessage}
                {Name}
                {EmailAddress}
                {Occupation}
                {PhoneNumber}
                {Enquiry}
                {Checkbox}
                {Recaptcha}
                {SubmitButton}
                {/* {Checkbox} */}
            </Node>
        </Module>
    );
};
